/// <reference types="vite/client" />

import { FC } from 'react';

const components = import.meta.glob('./components/**/*.tsx', { eager: true });

export const ICON_COMPS: Record<string, FC> = Object.keys(components).reduce(
  (memo, path) => {
    const key = path.replace(/\.\/components\/|\.tsx$/g, '');
    return {
      ...memo,
      [key]: (components[path] as any).default as FC,
    };
  },
  {},
);

export const ICONS_TYPES: Record<
  keyof typeof ICON_COMPS,
  keyof typeof ICON_COMPS
> = {};
Object.keys(ICON_COMPS).forEach((item) => {
  ICONS_TYPES[item] = item;
});
